import { ETransportationMode, CompanyDetailedDto, LinkCompanyListItemDto } from 'models/dtoTypes';

export interface OrganisationAttributes {
  name: string;
  displayName: string;
  hasUnlimitedSearches: boolean;
  hasUnlimitedCredits: boolean;
  isEvaluating: boolean;
  companyReportCsvFormat: string;
  billingType: string;
}

export interface TransactionAttributes {
  financialProduct: string;
  financialProductReference: string;
  buyerId: string;
  sellerId: string;
  transportationMode: ETransportationMode;
  originLocode: string;
  destinationLocode: string;
  hsCode: string;
  weightInKg: number;
  countryOfOrigin: string;
}

export interface SmartGovernanceAssignmentAttributes {
  assigneeId: string;
}

export interface CompanyListAttributes {
  organisationId?: string;
  name: string;
  description: string;
}

export interface ProductListAttributes {
  organisationId?: string;
  name: string;
  description: string;
}
export interface ProductListItemAttributes {
  id?: string;
  companyName?: string | null;
  countryCode?: string | null;
  certificates?: string[] | null;
  productDescription?: string | null;
}

export interface CallbackAttributes {
  organisationId?: string;
  callbackUrl: string;
  clientCertificationBase64?: string;
  passphrase?: string;
}

export interface UserAttributes {
  firstName: string;
  lastName: string;
  email: string;
  organisationId?: string;
  userRole?: string; // admin/tfp/sme
}

export interface CompanyListItemAttributes {
  id?: string;
  name?: string | null;
  countryCode?: string | null;
  registrationNumbers?: string | null;
  address?: string | null;
  postalCode?: string | null;
}

export interface CompanyDetailedDtoWithSelector extends CompanyDetailedDto {
  uniqueIdSelector: string;
}

export const mapToSearchCompanyListItemDto = (
  detailed: CompanyDetailedDtoWithSelector,
): LinkCompanyListItemDto => {
  const obj = {
    tradesunAIId: '',
    coriolisCompanyId: '',
  };
  if (detailed.id !== '00000000-0000-0000-0000-000000000000') {
    obj.coriolisCompanyId = detailed.id || '';
  } else {
    obj.tradesunAIId = detailed.tradesunAIId || '';
  }
  return obj;
};
